import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfterSection() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-76" data-mp="3ahk5zrqa9uxp">
      <div className="mx-auto max-w-5xl" data-id="element-77" data-mp="3ffbuebrpyyx5">
        <SectionHeading eyebrow="The transformation" title={<>What I want you to be able to do <em className="text-gold-600" data-id="element-79" data-mp="70ts6qogmdlg">after using the system</em></>} data-id="element-78" data-mp="3fgdh5di3l9up" />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-80" data-mp="bwilwddst09u">
          <div className="rounded-3xl border-2 border-danger/25 bg-white p-6 sm:p-8" data-id="element-81" data-mp="3teuymthetq46">
            <h3 className="flex items-center gap-3 font-serif text-2xl font-bold text-danger" data-id="element-82" data-mp="27qxgf7y4y3o">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-danger" data-id="element-83" data-mp="pxv0akdb8ttm">
                <XIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-84" data-mp="uo1myeo9i498" />
              </span>
              Before
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-85" data-mp="22p5tnqnchace">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-danger/5 px-4 py-3 text-base leading-snug text-ink" data-id="element-86" data-mp="1xpszsly2330b">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-87" data-mp="2cf8kbk6zuc7k" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-success/30 bg-navy-900 p-6 sm:p-8" data-id="element-88" data-mp="2ld11ktw9ztxl">
            <h3 className="flex items-center gap-3 font-serif text-2xl font-bold text-gold-400" data-id="element-89" data-mp="2gepqygy5pfeb">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-success" data-id="element-90" data-mp="2vbgu91aybb97">
                <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-91" data-mp="2qf06w9bkt0x6" />
              </span>
              After
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-92" data-mp="110v3v0ekkz1k">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-navy-800 px-4 py-3 text-base leading-snug text-white" data-id="element-93" data-mp="w1ii6izfpy0k">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-94" data-mp="1pp50g25m7xft" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-2xl font-bold leading-snug text-navy-900" data-id="element-95" data-mp="1zo41ayk52os9">
          I didn’t create this system to give you more information. I created it to help you get more value from the information you already have.
        </p>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-96" data-mp="2dezdajpxpm02">
          <CTAButton label="I want to make this change" data-id="element-97" data-mp="2dgagoifgwrqn" />
        </div>
      </div>
    </section>;
}